import { render, staticRenderFns } from "./m-product-short-info.vue?vue&type=template&id=4e0e41c4&scoped=true&"
import script from "./m-product-short-info.vue?vue&type=script&lang=js&"
export * from "./m-product-short-info.vue?vue&type=script&lang=js&"
import style0 from "./m-product-short-info.vue?vue&type=style&index=0&id=4e0e41c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e41c4",
  null
  
)

export default component.exports